import {matchingPrefixes} from './cnam.js';

// The hotel workdesk selector is narrower than the operator board and the phone.
// Never derive a hotel prefix from an agent name or a queue-only match.
export function hotelCalls(calls,properties,workspace){
 const allowed=new Set((properties||[]).map(p=>p.id));
 return (calls||[]).filter(call=>{
  if(call.ended||/^(ended|completed|outgoing|internal)$/i.test(call.state||'')||/^(outgoing|outbound|internal)$/i.test(call.direction||''))return false;
  if(call.screen_pop){
   return call.screen_pop.match==='prefix'&&allowed.has(call.screen_pop.property_id);
  }
  const name=call.caller_name||call.name||'';
  return (properties||[]).some(p=>matchingPrefixes(name,workspace?.profiles?.[p.id]?.prefixes||[]).length>0);
 });
}

export function selectedHotelCall(calls,selection,extension){
 return calls.find(c=>c.id===selection)||calls.find(c=>c.agents?.includes(extension))||calls[0]||null;
}
